import { Platform } from "utils/website";
import Constant from "./isomorphismConstant";
import { middleEast } from "./currency";

export const formatPriceWithPoint = function (price: number | string, bit = 2) {
	if (typeof price === "string") {
		price = parseFloat(price);
	}
	let base = Math.pow(10, bit);

	return (Math.round(price * base) / base).toFixed(bit);
};

export const stringToPrice = function (priceString: string) {
	return parseFloat(priceString.replace(/[^\.\d]/g, ""));
};

export function transferMixUnitPrice(integerPrice: number) {
	const price = integerPrice / 100;
	return Number(price.toFixed(2));
}

export const getBRLPrice = (currency: Constant, price: string) => {
	if (currency) {
		return currency + " " + Constant.priceGraph + (price ? price.replace(".", ",") : price);
	} else {
		return Constant.priceGraph + (price ? price.replace(".", ",") : price);
	}
};
const noNationalSmbols = (country) => {
	return Constant.currency === country;
};
const specialSymbol = (price, isOrigin, symbol) => {
	return isOrigin ? symbol + price : Constant.priceGraph + price;
};
export const transformProductPrice = (
	platform: Platform,
	price: string,
	isOrigin: boolean = false,
) => {
	if (platform === Platform.WEB) {
		return connectLtPrice(price, isOrigin);
	}
	return connectLtPriceForM(price, isOrigin);
};
export const connectLtPrice = (price: string, isOrigin: boolean) => {
	if (middleEast.some((i) => i === Constant.currency)) {
		return Constant.currency + " " + price;
	} else if (Constant.currency === "BRL") {
		return getBRLPrice(Constant.currency, price);
	} else if (noNationalSmbols("MXN")) {
		return specialSymbol(price, isOrigin, "$");
	} else if (noNationalSmbols("CHF")) {
		return specialSymbol(price, isOrigin, "₣");
	} else {
		return Constant.currency + " " + Constant.priceGraph + price;
	}
};

export const connectLtPriceForM = (price, isOrigin: boolean) => {
	if (middleEast.some((i) => i === Constant.currency)) {
		return Constant.currency + " " + price;
	} else if (Constant.currency === "JOD" || Constant.currency === "CAD") {
		return Constant.currency + " " + Constant.priceGraph + price;
	} else if (Constant.currency === "BRL") {
		return getBRLPrice(null, price);
	} else if (noNationalSmbols("MXN")) {
		return specialSymbol(price, isOrigin, "$");
	} else if (noNationalSmbols("CHF")) {
		return specialSymbol(price, isOrigin, "₣");
	} else {
		return Constant.priceGraph + price;
	}
};
